import FormNewChanges from "../../base/actions/FormNewChanges";

const formNewChanges: FormNewChanges = {
    changeRequestFinishedTitle: "Požadavek na změnu {type} byl dokončen.",
    updatedFromPlcTitle: "Došlo ke změně hodnot u {type} přímo na PLC jednotce.",
    dialogMessage: "Chcete načíst aktuální hodnoty?",
}

export default formNewChanges;